// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"4629af14","213":"bb9158bf","239":"795b32df","455":"381cdfe1","619":"feeae3a4","655":"1e903d2e"}[chunkId] + ".chunk.js";
};